import { v4 as uuidv4 } from 'uuid'

const getuuid = () => {
    if (typeof localStorage !== 'undefined') {
        if (localStorage.getItem('uuid')) {
            return localStorage.getItem('uuid')
        }
        const uid = uuidv4()
        localStorage.setItem('uuid', uid)
        return uid
    }
    return uuidv4()
}

export { getuuid }
